module.exports = __webpack_public_path__ + "static/medidas-caja-020c88b134083d56f6da4d3612ab47e0.jpg";